import styled from "styled-components";
import { useState } from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";

import { RAButtonSecondary, RATypography } from "@/components/customs";
import { selectAuthState } from "@/stores/slices/authSlice";
import { ModalActiveAccount, ModalRequestQuote, ModalStatus } from "@/components/ui/Modals";
import { NOTIFICATION_TYPE } from "@/config/constants";

export function AircraftRequestQuote({ title = "", description = "", buttonText = "" }) {
	const { user } = useSelector(selectAuthState);
	const [showRequestFlight, setShowRequestFlight] = useState(false);
	const [showStatus, setShowStatus] = useState(false);
	const [showModalActiveAccount, setShowModalActiveAccount] = useState(false);

	const onPressRequestQuote = () => {
		if (user && !user.activated) {
			setShowStatus(true);
			return;
		}
		setShowRequestFlight(true);
	};

	return (
		<Container>
			<WrapperContent>
				<WrapperHeader>
					<RATypography variant="h2" color="#fff">
						{title}
					</RATypography>
				</WrapperHeader>
				<Row style={{ marginBottom: "40px" }}>
					<Col xl={10} lg={12} md={18} sm={24} xs={24}>
						<RATypography variant="body3" color="#fff" top="12px" maxLines={10}>
							{description}
						</RATypography>
					</Col>
				</Row>
				<Row>
					<div style={{ position: "absolute", padding: 2 }}>
						<div className="center">
							<button className="btn" onClick={() => onPressRequestQuote()}>
								<svg width="247" height="52" viewBox="0 0 247 52" className="border">
									<rect x="1" y="1" width="245" height="50" rx="25" />
								</svg>
								<span>{buttonText || "REQUEST A QUOTE"}</span>
							</button>
							{/* </Link> */}
						</div>
					</div>
				</Row>
			</WrapperContent>

			{/* modals */}
			<ModalRequestQuote visible={showRequestFlight} onClose={() => setShowRequestFlight(false)} />
			<ModalStatus
				visible={showStatus}
				status={NOTIFICATION_TYPE.ERROR}
				title="You haven't verified your OTP yet!"
				note="Please verify your OTP to access all the features and benefits of our products"
				onClose={() => setShowStatus(false)}
				footer={
					<Row>
						<RAButtonSecondary
							title="VERIFY NOW"
							onClick={() => {
								setShowStatus(false);
								setTimeout(() => {
									setShowModalActiveAccount(true);
								}, 200);
							}}
						/>
					</Row>
				}
			/>
			<ModalActiveAccount
				visible={showModalActiveAccount}
				onClose={() => setShowModalActiveAccount(false)}
				onActiveSuccess={() => {
					setShowRequestFlight(true);
				}}
			/>
		</Container>
	);
}

const WrapperContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	/* padding: 0px 160px; */
	.ra-primary-button-text {
		color: #fff !important;
	}

	.center {
		width: 247px;
		height: 52px;
		/* position: absolute; */
	}

	.btn {
		width: 247px;
		height: 52px;
		border-radius: 50px;
		cursor: pointer;
		background: transparent;
		border: 1px solid #ffb11a;
		outline: none;
		transition: 2s ease-in-out;
		box-sizing: border-box;
		position: relative;
	}

	svg {
		position: absolute;
		left: -1px;
		top: -1px;
		fill: none;
		stroke: #404040;
		stroke-width: 2;
		stroke-dasharray: 100 560;
		stroke-dashoffset: 100;
		transition: 2s ease-in-out;
		z-index: 100;
		box-sizing: border-box;
	}

	.btn:hover {
		transition: 2s ease-in-out;
	}

	.btn:hover svg {
		stroke-dashoffset: -560;
	}

	.btn span {
		color: #fff;
		font-family: "DM Sans";
		font-weight: 500;
		font-size: 14px;
		/* line-height: 30px; */
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
`;
const WrapperHeader = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
	z-index: 1;
`;
const Container = styled.div`
	width: 100%;
	position: relative;
	top: 40%;
	/* height: 100vh; */
	/* Center and scale the image nicely */
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
